class Auth {

  constructor() {
    this.authenticated = false;
    this.token = "";
		this.credentials = null;
		this.additionalRoles = null;
    this.userId = null;
    this.role = null;
  }

  login(credentials, token, additionalRoles, userId, role) {
    this.authenticated = true;
    this.token = token;
		this.credentials = credentials;
		this.additionalRoles = additionalRoles;
    this.userId = userId;
    this.role = role;
  }

  logout() {
    this.authenticated = false;
  }

  isAuthenticated() {
    return this.authenticated;
  }

}

export default new Auth();
